import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ba-studisu-app-error-404-angebot-nicht-gefunden',
  templateUrl: './angebot-nicht-gefunden.component.html',
  styleUrls: ['angebot-nicht-gefunden.component.scss']
})
export class AngebotNichtGefundenComponent {
  private readonly router = inject(Router);

  async navigateToSuche() {
    await this.router.navigate(['/suche'], {
      queryParamsHandling: 'merge'
    });
  }
}
